import { render, staticRenderFns } from "./WorkspaceBrowserShell.vue?vue&type=template&id=b8a0377a"
import script from "./WorkspaceBrowserShell.vue?vue&type=script&lang=js"
export * from "./WorkspaceBrowserShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports